export default {"src":"/_next/static/media/SG.1c62930e.svg","height":20,"width":30};